import { render } from "./SetRackLot.vue?vue&type=template&id=c2261690"
import script from "./SetRackLot.vue?vue&type=script&lang=js"
export * from "./SetRackLot.vue?vue&type=script&lang=js"
script.render = render

export default script